import { ThemeProvider } from "@emotion/react";
import React from "react";

import theme from "~/theme";

import { MarketingProvider } from "~/context/MarketingContext";
import { StickyProvider } from "~/context/StickyContext";
import { LocationProvider } from "~/context/LocationContext";
import { CartProvider } from "~/context/CartContext";
import { TranslationProvider } from "~/context/TranslationContext";
import { QueryManagerProvider } from "~/context/QueryManagerContext";

export function onRenderBody({ setHtmlAttributes }) {
    setHtmlAttributes({ lang: "en-us" });
}

const GlobalContext = ({ element, props }) => {
    return (
        <QueryManagerProvider>
            <LocationProvider pageProps={props}>
                <TranslationProvider pageProps={props}>
                    <MarketingProvider>
                        <StickyProvider>
                            <CartProvider>
                                <ThemeProvider {...{ theme }}>
                                    {element}
                                </ThemeProvider>
                            </CartProvider>
                        </StickyProvider>
                    </MarketingProvider>
                </TranslationProvider>
            </LocationProvider>
        </QueryManagerProvider>
    );
};

export const wrapRootElement = ({ element }) => {
    return <GlobalContext element={element} props={element.props} />;
};

export const wrapPageElement = ({ element, props }) => {
    return <GlobalContext element={element} props={props} />;
};
